/* -------------------------------------------------------------
   Sticky-header offset → CSS variable
   ------------------------------------------------------------- */
(() =>
{
	const header = document.querySelector('.jsSiteHeader');
	if (!header) return;                     // nothing to do

	let finalTimer = null;
	const FINAL_FIX_MS = 300;                // matches your 300 ms animation

	/* ---- live update (called on every rAF while scrolling) ---- */
	const updateLive = () =>
	{
		const bottom = Math.round(Math.max(0, header.getBoundingClientRect().bottom));
		document.documentElement.style.setProperty(
			'--headerBottomFromViewportTop',
			`${bottom}px`
		);
	};

	/* ---- schedule the “final” correction after inactivity ---- */
	const scheduleFinal = () =>
	{
		clearTimeout(finalTimer);
		finalTimer = setTimeout(updateLive, FINAL_FIX_MS);
	};

	/* ---- scroll handler (throttled live + final) ---- */
	let ticking = false;
	const onScroll = () =>
	{
		// live update – at most once per animation frame
		if (!ticking)
		{
			requestAnimationFrame(() =>
			{
				updateLive();
				ticking = false;
			});
			ticking = true;
		}
		// always push the final fix forward
		scheduleFinal();
	};

	/* ---- resize handler ---- */
	const onResize = () =>
	{
		updateLive();       // instant reaction to width changes
		scheduleFinal();    // in case the header height changed
	};

	/* ---- wire everything up ---- */
	window.addEventListener('scroll', onScroll, { passive: true });
	window.addEventListener('resize', onResize);

	/* ---- initial value ---- */
	updateLive();

	/* -------------------------------------------------------------
	   PUBLIC API – other scripts (e.g. urgent-message dismiss)
	   can force an immediate live update:
		  window.updateHeaderOffset?.();
	   ------------------------------------------------------------- */
	window.updateHeaderOffset = () =>
	{
		updateLive();       // instant
		scheduleFinal();    // still guarantee a clean value after 300 ms
	};
})();